<template>
	<div id="workflow-tags" class="workflow-tags" v-if="!labNotesActive">
		<div class="workflow-group" v-for="group in displayedTagGroups" :key="group.id" :data-test="`workflow-tag-group-${group.name}`">
			<div class="caption">{{ group.name }}</div>
			<div class="workflow-group-tags">
				<div
					class="workflow-tag caption-2"
					:class="{active: isTagActive(tag)}"
					v-for="tag in group.tags"
					:key="tag.id"
					@click="selectTag(tag)"
					:data-test="`workflow-tag-${tag.name}`"
				>
					{{ tag.name }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'WorkflowTags',
	props: {
		labNotesActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		tags() {
			return this.$store.getters['tags/uniqueAssignedTags'];
		},
		tagGroups() {
			return this.$store.getters['tags/uniqueAssignedTagGroups']('WORKFLOW');
		},
		displayedTagGroups() {
			return this.tagGroups.reduce((acc, group) => {
				//filter groups with less than 2 tags in current workflow, sorted by order in group.tags
				let existingTags = group.tags.reduce((tags, tagId) => {
					return [...tags, ...this.tags.filter((tag) => tag.id === tagId)];
				}, []);
				return existingTags.length > 1 ? [...acc, {...group, tags: existingTags}] : acc;
			}, []);
		},
		productKeys() {
			return this.$store.getters['workflow/allProducts'].map((p) => p.key);
		},
		activeTags() {
			return this.$store.getters['tags/activeWorkflowTags'];
		},
	},
	methods: {
		isTagActive(tag) {
			return Object.values(this.activeTags).some((tagGroup) => tagGroup.has(tag.id));
		},
		selectTag(tag) {
			this.isTagActive(tag)
				? this.$store.dispatch('tags/unsetActiveTag', tag)
				: this.$store.dispatch('tags/setActiveTag', tag);
		},
	},
};
</script>
<style scoped lang="scss">
.workflow-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 0 20px;
    width: fit-content;
	.workflow-group {
		margin: 16px 0;
		.workflow-group-tags {
			@include flexRow;
			flex-wrap: wrap;
			.workflow-tag {
				white-space: nowrap;
				border: 1px solid;
				border-radius: 10px;
				border-color: $color-text-grey;
				padding: 4px 8px;
				margin: 4px 8px 4px 0;
				cursor: pointer;
				&.active {
					border-color: $color-blue;
					border-width: 2px;
					background: $color-super-light-blue;
					color: $color-blue;
				}
			}
		}
	}
}
</style>
